module.exports = __webpack_public_path__ + "static/media/membrete.f87b4b86.jpg";